import * as yup from 'yup';


import {geoConstants} from '../../Geo';


export const ADDRESS_LINE_MAX_LENGTH = 100;
export const ADDRESS_LINE_MIN_LENGTH = 2;

export const CITY_MAX_LENGTH = 100;
export const CITY_MIN_LENGTH = 2;

export const NAME_MAX_LENGTH = 100;
export const NAME_MIN_LENGTH = 2;

export const NAME_ADDITION_MAX_LENGTH = 100;
export const NAME_ADDITION_MIN_LENGTH = 2;

export const POST_CODE_MAX_LENGTH = 20;
export const POST_CODE_MIN_LENGTH = 2;

export const STATE_MAX_LENGTH = 50;
export const STATE_MIN_LENGTH = 2;



export const SCHEMA_ADDRESS_LINE_1 = yup.string()
    .nullable()
    .min(ADDRESS_LINE_MIN_LENGTH)
    .max(ADDRESS_LINE_MAX_LENGTH)
    .required()
    .strictText();

export const SCHEMA_ADDRESS_LINE_2 = yup.string()
    .nullable()
    .max(ADDRESS_LINE_MAX_LENGTH)
    .strictText();

export const SCHEMA_CITY = yup.string()
    .nullable()
    .min(CITY_MIN_LENGTH)
    .max(CITY_MAX_LENGTH)
    .required()
    .strictText();

export const SCHEMA_NAME = yup.string()
    .nullable()
    .min(NAME_MIN_LENGTH)
    .max(NAME_MAX_LENGTH)
    .required()
    .strictText();

export const SCHEMA_NAME_ADDITION = yup.string()
    .nullable()
    .min(NAME_ADDITION_MIN_LENGTH)
    .max(NAME_ADDITION_MAX_LENGTH)
    .strictText();

export const SCHEMA_POST_CODE = yup.string()
    .nullable()
    .min(POST_CODE_MIN_LENGTH)
    .max(POST_CODE_MAX_LENGTH)
    .required()
    .strictText();

export const SCHEMA_STATE = yup.string()
    .nullable()
    .min(STATE_MIN_LENGTH)
    .max(STATE_MAX_LENGTH)
    .strictText();


export const SCHEMA_ADDRESS = yup.object()
    .shape({
        addressLine1: SCHEMA_ADDRESS_LINE_1,
        addressLine2: SCHEMA_ADDRESS_LINE_2,
        city: SCHEMA_CITY,
        countryAlpha2: geoConstants.SCHEMA_COUNTRY_ALPHA2,
        postCode: SCHEMA_POST_CODE,
        state: SCHEMA_STATE
    });


export const SCHEMA_ADDRESS_NAME_FIELD = yup.object()
    .shape({
        name: SCHEMA_NAME,
        nameAddition: SCHEMA_NAME_ADDITION
    });


export const SCHEMA_ADDRESS_WITH_NAME = SCHEMA_ADDRESS.concat(SCHEMA_ADDRESS_NAME_FIELD);
